import React from "react";

export default function Input({ type, step, placeholder, ...props }) {
  return (
    <div className="quantity q-style1 me-4 mb-1">
      <input
        type={type}
        className="qty-input "
        step={type === "number" ? step || "0.01" : undefined}
        min={type === "number" ? "0" : undefined}
        placeholder={placeholder}
        {...props}
        
      />
    </div>
  );
}
